import { useEffect, useRef, useState } from 'react';
import { UNITS, UNIT_NAMES, type LengthUnit } from '@flobi/artwork-core';
import { Menu } from '../../ui/menu';
import { rulerLayout, type RulerInset } from '../rulerLayout';

/** Keyboard-accessible unit control over the canvas-painted corner. */
export function RulerUnits({ inset, units, onUnits }: { inset: RulerInset; units: LengthUnit; onUnits: (unit: LengthUnit) => void }) {
  const anchor = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState(() => ({ width: window.innerWidth, height: window.innerHeight }));
  useEffect(() => {
    const resize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  const corner = rulerLayout(size.width, size.height, inset).corner;
  if (!corner) return null;
  return <>
    <button ref={anchor} type="button" aria-label={`Ruler units: ${UNIT_NAMES[units]}`} aria-haspopup="menu" aria-expanded={open}
      title="Ruler units" className="ruler-unit-button" style={{ left: corner.x, top: corner.y, width: corner.width, height: corner.height }}
      onClick={() => setOpen(value => !value)} />
    <Menu open={open} anchor={anchor.current} onClose={() => setOpen(false)} label="Ruler units" width={180}
      items={UNITS.map(unit => ({ id: unit, label: UNIT_NAMES[unit], checked: units === unit, onSelect: () => onUnits(unit) }))} />
  </>;
}
